import { useEffect } from "react";
import actions from "../actions/actions";
import { GuiButton } from "../components/global-ui/gui-button.jsx";
import "../styles/password-created.scss";

const PasswordCreated = () => {
  useEffect(() => {
    document.body.classList.add("reset-password-page");
    document.body.style.backgroundColor = "#b8c9df";

    // Push a history entry so the browser back button can be intercepted and
    // redirected to Sign In instead of returning to Create New Password.
    window.history.pushState({ passwordCreated: true }, "");
    const handlePopState = () => {
      actions.passwordRecovery.changeScreen("login");
    };
    window.addEventListener("popstate", handlePopState);

    return () => {
      document.body.classList.remove("reset-password-page");
      document.body.style.backgroundColor = "";
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);

  return (
    <div className="reset-password-wrapper">
      <div className="reset-password-brand">
        <img src="/lib/images/Vector.svg" alt="High Ground Solutions" />
        <div className="reset-password-brand-caption">
          High Ground Solutions
        </div>
      </div>

      <div className="reset-password-container password-created-container">
        <div className="password-created-icon">
          <i className="far fa-check-circle"></i>
        </div>

        <div className="reset-password-header">
          <h1 className="reset-password-title">New Password Created</h1>
          <p className="reset-password-subtitle">
            Your new password was successfully created.
          </p>
        </div>

        <GuiButton
          onClick={() => actions.passwordRecovery.changeScreen("login")}
          dataQa="sign-in"
        >
          Sign In
        </GuiButton>
      </div>
    </div>
  );
};

export default PasswordCreated;
